import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PlanType from './PlanType';

const backdropStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#000',
  opacity: 0.5,
};

class SelectPlan extends Component {
  getPlanTitle = () => {
    const { referrer, originPlanType, isPremiumExpired, subscriptionPlan } =
      this.props;

    let planTitle = '$150/yr';

    if (referrer.includes('cdbaby') || referrer.includes('soundrop')) {
      if (
        originPlanType === 'premium' &&
        !isPremiumExpired &&
        !subscriptionPlan.includes('-cdbaby')
      ) {
        planTitle = '$150/yr';
      } else {
        planTitle = '$150/yr';
      }
    }

    return planTitle;
  };

  getButtonTitle = (type) => {
    const { originPlanType, isCanceledSubscription, isPremiumExpired } =
      this.props;

    let title = '';
    if (type === 'free') {
      if (originPlanType === 'free' || isCanceledSubscription) {
        title = 'Current Plan';
      } else {
        title = 'Select Plan';
      }
    } else if (type === 'premium') {
      if (
        originPlanType === 'premium' &&
        !isPremiumExpired &&
        !isCanceledSubscription
      ) {
        title = 'Current Plan';
      } else {
        if (
          originPlanType === 'free' ||
          isCanceledSubscription ||
          originPlanType === 'essential'
        ) {
          title = 'Select Plan/Upgrade';
        } else {
          title = 'Select Plan';
        }
      }
    }

    return title;
  };

  onHandlePlan = (type) => {
    const { originPlanType, isCanceledSubscription, isPremiumExpired } =
      this.props;

    if (type === 'free') {
      if (originPlanType === 'free' || isCanceledSubscription) {
        return;
      }
      this.props.handleFreeDowngrade();
    } else {
      if (
        originPlanType === 'premium' &&
        !isPremiumExpired &&
        !isCanceledSubscription
      ) {
        return;
      } else {
        this.props.handlePlan(type);
      }
    }
  };

  render() {
    const {
      show,
      showAllPlan,
      showCheckoutStep,
      handlePlan,
      hidePlanModal,
      exitedPlanModal,
    } = this.props;

    return (
      <Modal
        dialogClassName="user-plan-modal select-plan-modal"
        show={show}
        onHide={hidePlanModal}
        onExited={exitedPlanModal}
        renderBackdrop={() => <div style={backdropStyle} />}
      >
        <Modal.Header closeButton>
          <div className="modal-title">Select a Plan</div>
        </Modal.Header>
        <Modal.Body>
          {showAllPlan ? (
            <div className="plan-list">
              {!showCheckoutStep && (
                <PlanType
                  type="free"
                  planTitle="Free"
                  buttonTitle={this.getButtonTitle('free')}
                  handlePlan={() => this.onHandlePlan('free')}
                />
              )}
              <PlanType
                type="premium"
                planTitle={this.getPlanTitle()}
                buttonTitle={this.getButtonTitle('premium')}
                handlePlan={(type) => this.onHandlePlan(type)}
              />
            </div>
          ) : (
            <div className="plan-list">
              <PlanType
                type="premium"
                planTitle={this.getPlanTitle()}
                handlePlan={handlePlan}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="buttons">
            <button className="nevermind" onClick={hidePlanModal}>
              Nevermind, I'll upgrade later.
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SelectPlan;



// WEBPACK FOOTER //
// src/components/UserPlan/SelectPlan.jsx